<template>
  <div>
    <Head title="Histórico de consultas" />
    <div class="shadow_box rounded-lg p-6">
      <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">Histórico de consultas</h1>

      <radio-input-group
        class="mt-4 lg:inline-block mb-4"
        :options="optionsRadio"
        label="Filtrar por:"
        name="filterby"
        v-model="filterby" />

      <data-table
        v-if="loadTable"
        v-model:columns="columns"
        :query='{ "date_start": dateStart, "date_end": dateEnd }'
        :route="`appointments-history/list?filterby=${ filterby }`"
        no-data-label="Nenhum agendamento cadastrado"
        no-result-label="Nenhum agendamento encontrado"
      >
        <template #table.cell.content.professional_name="{ value, row }">
          <popover class="mr-8 md:mr-0" placement="bottom-end">
            <template #default>
              <span class="text-primary font-semibold cursor-pointer">
                {{ row.professional.user.name }}
              </span>
            </template>
            <template #dropdown>
              <div class="p-4 bg-white shadow_box rounded-lg text-xs">
                <div class="flex flex-nowrap">
                  <div v-if="row.professional.user?.photo?.url" class="mr-4">
                    <img :src="row.professional.user.photo.url" class="rounded-full w-20" />
                  </div>
                  <div>
                    <div class="text-primary font-semibold">{{ row.professional.user.name }}</div>
                    <div>CPF: {{ row.professional.cpf }}</div>
                    <div>E-mail: {{ row.professional.user.email }}</div>
                    <div>{{ row.professional.class_entity_label }}: {{ row.professional.class_number }}-{{ row.professional.uf }}</div>
                    <div>Especialidade: <span class="inline-flex" v-html="row.professional.specialties_labels"></span></div>
                  </div>
                </div>
              </div>
            </template>
          </popover>
        </template>
        <template #grid.content.body.professional_name="{ value, row }">
          <popover class="mr-8 md:mr-0" placement="bottom-end">
            <template #default>
              <span class="text-primary font-semibold cursor-pointer">
                {{ row.professional.user.name }}
              </span>
            </template>
            <template #dropdown>
              <div class="p-4 bg-white shadow_box rounded-lg text-xs">
                <div class="flex flex-nowrap">
                  <div v-if="row.professional.user?.photo?.url" class="mr-4">
                    <img :src="row.professional.user.photo.url" class="rounded-full w-20" />
                  </div>
                  <div>
                    <div class="text-primary font-semibold">{{ row.professional.user.name }}</div>
                    <div>CPF: {{ row.professional.cpf }}</div>
                    <div>E-mail: {{ row.professional.user.email }}</div>
                    <div>{{ row.professional.class_entity_label }}: {{ row.professional.class_number }}-{{ row.professional.uf }}</div>
                    <div>Especialidade: <span class="inline-flex" v-html="row.professional.specialties_labels"></span></div>
                  </div>
                </div>
              </div>
            </template>
          </popover>
        </template>
        <template #table.cell.content.patient_name="{ value, row }">
          <popover class="mr-8 md:mr-0" placement="bottom-end">
            <template #default>
              <span class="text-primary font-semibold cursor-pointer">
                {{ row.patient.user.name }}
              </span>
            </template>
            <template #dropdown>
              <div class="p-4 bg-white shadow_box rounded-lg text-xs">
                <div class="flex flex-nowrap">
                  <div v-if="row.patient.user?.photo?.url" class="mr-4">
                    <img :src="row.patient.user.photo.url" class="rounded-full w-20" />
                  </div>
                  <div>
                    <div class="text-primary font-semibold">{{ row.patient.user.name }}</div>
                    <div v-if="row.patient.cpf">CPF: {{ row.patient.cpf }}</div>
                    <div v-if="row.patient.birthdate">Data de nascimento: {{ this.$filters.formatDateTime(row.patient.birthdate) }}</div>
                    <div v-if="row.patient.user.email">E-mail: {{ row.patient.user.email }}</div>
                  </div>
                </div>
              </div>
            </template>
          </popover>
        </template>

        <template #table.cell.content.status="{ value, row }">
          <Popover>
            <template #default>
              <span class="text-primary font-semibold cursor-pointer">
                {{ statusAppointment[value].label }}
              </span>
            </template>

            <template #dropdown>
              <div class="p-4 bg-white shadow_box rounded-lg text-xs">
                <div class="flex flex-nowrap">
                  {{ statusAppointment[value].description }}
                </div>
              </div>
            </template>
          </Popover>
        </template>

        <template #grid.content.body.patient_name="{ value, row }">
          <popover class="mr-8 md:mr-0" placement="bottom-end">
            <template #default>
              <span class="text-primary font-semibold cursor-pointer">
                {{ row.patient.user.name }}
              </span>
            </template>
            <template #dropdown>
              <div class="p-4 bg-white shadow_box rounded-lg text-xs">
                <div class="flex flex-nowrap">
                  <div v-if="row.patient.user?.photo?.url" class="mr-4">
                    <img :src="row.patient.user.photo.url" class="rounded-full w-20" />
                  </div>
                  <div>
                    <div class="text-primary font-semibold">{{ row.patient.user.name }}</div>
                    <div>CPF: {{ row.patient.cpf }}</div>
                    <div>RG: {{ row.patient.rg }}</div>
                    <div>E-mail: {{ row.patient.user.email }}</div>
                  </div>
                </div>
              </div>
            </template>
          </popover>
        </template>
        <template #after.reload-button>
          <date-range-input class="w-full" placeholder="Período" v-model="selectedDate" />
        </template>
      </data-table>
    </div>
  </div>
</template>

<script>
import { Head, Link, useForm } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout/Layout'
import DataTable from '@/Shared/Components/DataTable'
import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'
import format from 'date-fns/format';
import Popover from '@/Shared/Components/Popover'
import DateRangeInput from '@/Shared/Fields/DateRangeInput'
import RadioInputGroup from '@/Shared/Fields/RadioInputGroup.vue'


const optionsRadio = [
  {
    label: 'Consultas ativas',
    value: 'active',
  },
  {
    label: 'Consultas canceladas',
    value: 'cencelled',
  },
]



const statusAppointment = {
  active: {
    label: 'Ativo',
    description: 'A consulta esta ativa',
  },

  completed: {
    label: 'Completa',
    description: 'A consulta foi concluida',
  },

  cancelled: {
    label: 'Cancelado',
    description: 'A consulta não foi paga no prazo',
  },

  cancelled_professional: {
    label: 'Cancelado',
    description: 'A consulta foi cancelada pelo profissional',
  },

  cancelled_patient: {
    label: 'Cancelado',
    description: 'A consulta foi cancelada pelo paciente',
  },
}


export default {
  props: {
    totalDay: 0,
    totalMonth: 0,
    dottedDates: {
      type: Array,
      default: [],
    },
  },
  components: {
    Head,
    DataTable,
    format,
    Popover,
    DateRangeInput,
    RadioInputGroup,
  },
  layout: Layout,
  setup() {
    const user = computed(() => usePage().props.value.auth.user)

    return {
      user,
      statusAppointment,
      optionsRadio,
    }
  },
  watch: {
    selectedDate(selectedDateNew, selectedDateOld) {
      this.reloadTable();
    },

    filterby() {
      this.reloadTable()
    },
  },
  computed: {
    dateStart: function() {
      return this.selectedDate && this.selectedDate[0] ? format(this.selectedDate[0], 'yyyy-MM-dd') : '';
    },
    dateEnd: function() {
      return this.selectedDate && this.selectedDate[1] ? format(this.selectedDate[1], 'yyyy-MM-dd') : '';
    },
  },
  mounted() {
    //this.selectedDate = new Date();
  },
  data() {
    return {
      monthYear: null,
      selectedDate: [],
      loadTable: true,
      filterby: '',

      columns: [
        {
          uniqid: 'professional_name',
          label: 'Profissional',
          field: 'professional_user.name',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
        },
        {
          uniqid: 'patient_name',
          label: 'Paciente',
          field: 'patient_user.name',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => `${row.patient.user.name}`,
        },
        {
          uniqid: 'specialty',
          label: 'Especialidade',
          field: 'specialties.name',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.specialty ? row.specialty.name : ''
        },
        {
          uniqid: 'status',
          label: 'Status da Consulta',
          field: 'status',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
        },
        {
          uniqid: 'type',
          label: 'Segmento',
          field: 'patient.b2b',
          visible: true,
          sortable: false,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.patient?.b2b === true ? 'B2B' : 'B2C',
        },
        {
          uniqid: 'date_start',
          label: 'Data da Consulta',
          field: 'date_start',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => this.$filters.formatDate(row.date_start),
        },
        {
          uniqid: 'date_end',
          label: 'Horário',
          field: 'date_end',
          visible: true,
          sortable: false,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.date_start.substr(10, 6) + ' - ' + row.date_end.substr(10, 6),
        },
        {
          uniqid: 'total',
          label: 'Valor Cobrado',
          field: 'payments.total',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.patient?.b2b === true ? 'N/A' : (row.total ?? '—'),
        },
        {
          uniqid: 'commission_amount',
          label: 'Valor da Comissão',
          field: 'payments.commission_amount',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.patient?.b2b === true ? 'N/A' : (row.commission_amount ?? '—'),
        },
      ],
    }
  },
  methods: {
    reloadTable() {
      this.loadTable = false;
      setTimeout(() => this.loadTable = true, 10);
    },
  },

  // setup() {
  //   return {
  //     statusAppointment, optionsRadio,
  //   }
  // }
}
</script>
